<div style="position: relative">
	<app-loader [showLoader]="showLoad"></app-loader>
	<div
		class="c-portlet o-block u-width-100p _u-width-100p stats-container u-shadow-mini {{
			sectionclass
		}} u-color-white-900 u-bg-accent-2"
	>
		<div class="c-portlet__header o-stack o-stack--center o-stack--splitted u-px-small u-py-mini c-portlet-gap">
			<div class="o-stack__cell">
				<h5 class="u-color-white-900">{{ sectiontitle }}</h5>
				<span *ngIf="downloadConfiguration.enableDownload && hasData" class="datatable-icon">
					<a href="javascript:void(0)" class="datatable_download_icon" (click)="downloadCSV($event)" target="_blank">
						<i class="fa fa-download" aria-hidden="true"></i>
					</a>
				</span>
			</div>
		</div>
		<div class="analytics-portlet-content u-pt-small lift_quick_stats_portlet_content" [ngClass]="{'no-daily-stats-data-quick-stats': !hasData}" >
			<div
				class="o-stack o-stack--center _u-px-small"
				*ngIf="quickStatsData && hasData"
				[ngClass]="{ 'no-youtube-views': !youtubeViewsPermission, 'has-yotube-views': youtubeViewsPermission }"
			>
				<span
					class="o-stack__cell content_mainCls"
					appTooltip
					title="Number of ads shown to users"
					data-size="big"
					[options]="tooltipOptions"
				>
					<h5 class="u-color-white-900">
						<span *ngIf="legends && legends[0]">{{ legends[0].displayName }}</span
						><span *ngIf="!legends.length">Impressions</span>
					</h5>
					<span
						class="u-font-medium u-lh-normal u-opacity-80p"
						*ngIf="quickStatsData.impressions; else impressionsblock"
						>{{ quickStatsData.impressions | formatNumber }}</span
					>
					<ng-template #impressionsblock>
						<span class="u-font-small u-lh-normal u-opacity-80p"> -- </span>
					</ng-template>
				</span>

				<div
					class="o-stack__cell content_mainCls"
					appTooltip
					title="Percent of video ads that are played through their entire duration to completion"
					data-size="big"
					[options]="tooltipOptions"
				>
					<h5 class="u-color-white-900">
						<span *ngIf="legends && legends[1]">{{ legends[1].displayName }}</span
						><span *ngIf="!legends.length">Completion Rate</span>
					</h5>
					<span *ngIf="!isR8" class="u-font-medium u-lh-normal u-opacity-80p"
						>{{ quickStatsData.completionsPercentage }}%</span
					>
					<span
						*ngIf="isR8"
						appTooltip
						title="Completion Rate"
						data-size="big"
						[options]="tooltipOptions"
						class="u-font-medium u-lh-normal u-opacity-80p"
						>{{ quickStatsData.completionsPercentage }}%</span
					>
					<div
						class="u-color-white-900 span_intraction"
						*ngIf="quickStatsData.completions; else completionsBlock"
						style="font-size: 1.2em"
					>
						{{ quickStatsData.completions | formatNumber }}
					</div>
					<ng-template #completionsBlock>
						<div class="u-color-white-900 span_intraction" style="font-size: 0.825em">--</div>
					</ng-template>
				</div>
				<div
					class="o-stack__cell content_mainCls"
					appTooltip
					title="Clicks + View Throughs"
					data-size="big"
					[options]="tooltipOptions"
				>
					<h5 class="u-color-white-900">
						<span *ngIf="legends && legends[2]">{{ legends[2].displayName }}</span
						><span *ngIf="!legends.length">Visits</span>
					</h5>
					<span *ngIf="!isR8" class="u-font-medium u-lh-normal u-opacity-80p"
						>{{ quickStatsData.visitsPercentage }}%</span
					>
					<span
						*ngIf="isR8"
						appTooltip
						title="Visits Rate"
						data-size="big"
						[options]="tooltipOptions"
						class="u-font-medium u-lh-normal u-opacity-80p"
						>{{ quickStatsData.visitsPercentage }}%</span
					>
					<div
						class="u-color-white-900 span_intraction"
						*ngIf="quickStatsData.totalVisits; else visitsblock"
						style="font-size: 1.2em"
					>
						{{ quickStatsData.totalVisits | formatNumber }}
					</div>
					<ng-template #visitsblock>
						<div class="u-color-white-900 span_intraction" style="font-size: 1.2em">--</div>
					</ng-template>
				</div>
				<div
					class="o-stack__cell content_mainCls"
					appTooltip
					title="Visits to conversion page by impressioned users (who did not click)"
					data-size="big"
					[options]="tooltipOptions"
				>
					<h5 class="u-color-white-900">
						<span *ngIf="legends && legends[3]">{{ legends[3].displayName }}</span
						><span *ngIf="!legends.length">View Throughs</span>
					</h5>
					<span *ngIf="!isR8" class="u-font-medium u-lh-normal u-opacity-80p"
						>{{ quickStatsData.viewThroughsPercentage }}%</span
					>
					<span
						*ngIf="isR8"
						appTooltip
						title="View Throughs Rate"
						data-size="big"
						[options]="tooltipOptions"
						class="u-font-medium u-lh-normal u-opacity-80p"
						>{{ quickStatsData.viewThroughsPercentage }}%</span
					>
					<div
						class="u-color-white-900 span_intraction"
						*ngIf="quickStatsData.viewThroughs; else viewthroughblock"
						style="font-size: 1.2em"
					>
						{{ quickStatsData.viewThroughs | formatNumber }}
					</div>
					<ng-template #viewthroughblock>
						<div class="u-color-white-900 span_intraction" style="font-size: 1.2em">--</div>
					</ng-template>
				</div>
				<div
					class="o-stack__cell content_mainCls"
					appTooltip
					title="Number of user clicks on ads"
					data-size="big"
					[options]="tooltipOptions"
				>
					<h5 class="u-color-white-900">
						<span *ngIf="legends && legends[4]">{{ legends[4].displayName }}</span
						><span *ngIf="!legends.length">Clicks</span>
					</h5>
					<span *ngIf="!isR8" class="u-font-medium u-lh-normal u-opacity-80p"
						>{{ quickStatsData.clicksPercentage }}%</span
					>
					<span
						*ngIf="isR8"
						appTooltip
						title="Clicks Rate"
						data-size="big"
						[options]="tooltipOptions"
						class="u-font-medium u-lh-normal u-opacity-80p"
						>{{ quickStatsData.clicksPercentage }}%</span
					>
					<div
						class="u-color-white-900 span_intraction"
						*ngIf="quickStatsData.clicks; else clicksblock"
						style="font-size: 1.2em"
					>
						{{ quickStatsData.clicks | formatNumber }}
					</div>
					<ng-template #clicksblock>
						<div class="u-color-white-900 span_intraction" style="font-size: 1.2em">--</div>
					</ng-template>
				</div>
				<div
					class="o-stack__cell content_mainCls"
					appTooltip
					title="A YouTube View is counted when someone watches a complete ad that’s 11-30 seconds long, someone watches at least 30 seconds of an ad that’s more than 30 seconds long, or someone interacts with the ad."
					data-size="big"
					[options]="tooltipOptions"
					*ngIf="legends && legends[5] && youtubeViewsPermission"
				>
					<h5 class="u-color-white-900">
						<span>{{ legends[5].displayName }}</span
						><span *ngIf="!legends.length">YouTube Views</span>
					</h5>
					<span *ngIf="!isR8" class="u-font-medium u-lh-normal u-opacity-80p"
						>{{ quickStatsData.youtubeViewsPercentage }}%</span
					>
					<span
						*ngIf="isR8"
						appTooltip
						title="YouTube Views Rate"
						data-size="big"
						[options]="tooltipOptions"
						class="u-font-medium u-lh-normal u-opacity-80p"
						>{{ quickStatsData.youtubeViewsPercentage }}%</span
					>
					<div
						class="u-color-white-900 span_intraction"
						*ngIf="quickStatsData.youtubeviews; else youtubeviewsblock"
						style="font-size: 1.2em"
					>
						{{ quickStatsData.youtubeviews | formatNumber }}
					</div>
					<ng-template #youtubeviewsblock>
						<div class="u-color-white-900 span_intraction" style="font-size: 1.2em">--</div>
					</ng-template>
				</div>
			</div>
			<div class="no-data-container" *ngIf="!hasData">
				<div
					class="c-portlet o-block u-width-100p _u-width-100p stats-container u-shadow-mini {{
						sectionclass
					}} u-color-white-900 u-bg-accent-2"
				>
					<div class="c-portlet__header o-stack o-stack--center o-stack--splitted u-px-small u-py-mini c-portlet-gap">
						<div class="o-stack__cell">
							<h5 class="u-color-white-900">{{ sectiontitle }}</h5>
						</div>
					</div>
					<div class="map-no-data" style="text-align: center; color: #fff">No Data to Display</div>
				</div>
			</div>
		</div>
	</div>
</div>
